export default {"src":"/_next/static/media/norton-logo-67-26.eb9a8d96.svg","height":26,"width":67};